import axios from 'axios';
import config from '../config/environment';

// API Base URL configuration using environment config
const API_BASE_URL = config.API_BASE_URL;

console.log('🌍 Environment:', config.ENVIRONMENT);
console.log('🔗 API Base URL:', API_BASE_URL);

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Let the browser set multipart boundary — required for Excel/photo uploads
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      if (config.headers && typeof config.headers.delete === 'function') {
        config.headers.delete('Content-Type');
      } else if (config.headers) {
        delete config.headers['Content-Type'];
        delete config.headers['content-type'];
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    console.log('📥 API Response:', {
      status: response.status,
      data: response.data,
      headers: response.headers
    });
    return response;
  },
  (error) => {
    console.error('❌ API Response Error:', {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    
    if (error.response?.status === 401) {
      console.log('🔒 Unauthorized, redirecting to login');
      localStorage.removeItem('token');
      localStorage.removeItem('admin');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Admin API calls
export const adminAPI = {
  login: (credentials) => api.post('/admin/login', credentials),
  getProfile: () => api.get('/admin/profile'),
};

// Employee API calls
export const employeeAPI = {
  getAll: () => api.get('/employee'),
  getById: (id) => api.get(`/employee/${id}`),
  getByCode: (code) => api.get(`/employee/profile/${code}`),
  create: (data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });
    return api.post('/employee', formData);
  },
  update: (id, data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });
    return api.put(`/employee/${id}`, formData);
  },
  delete: (id) => api.delete(`/employee/${id}`),
  generateQR: (id) => api.post(`/employee/${id}/generate-qr`),
};

// Excel API calls
export const excelAPI = {
  import: (formData) => api.post('/excel/import', formData),
  downloadTemplate: () => api.get('/excel/template', {
    responseType: 'blob',
  }),
};

// Health check
export const healthCheck = () => api.get('/health');

export default api; 